<!--
 * @FileDescription: 期初库存调整查询（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="material-top">
            <div class="material-top-left">
                <a-form :form="form"
                        class="materia-form"
                        layout="inline"
                >
                    <a-row :gutter="24">
                        <a-col :md="4" :sm="8">
                            <a-form-item>
                                <a-select  v-decorator="['storageId',{ rules: [{ required: false}] },]"
                                           placeholder="请选择仓库"
                                           @change="handleChangeStorage"
                                >
                                    <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
                                    <a-select-option v-for="item in storageList" :key="item.id">{{item.storageName}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="4" :sm="8">
                            <a-form-item>
                                <a-input v-decorator="['keywords']" placeholder="请输入商品名称/品牌/型号/规格查询" />
                            </a-form-item>
                        </a-col>
                        <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                        <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
                    </a-row>
                </a-form>
            </div>
          </div>
          <div class="adjustment-table">
              <div class="adjustment-table-item" @click="clickTab(1)" :class="tabIndex == 1 ? 'adjustment-table-item-active' :''">
                  <img src="@/assets/image/adjustment-img4.png" v-if="tabIndex == 1"/>
                  <img src="@/assets/image/adjustment-img1.png" v-else />
                  <span>按商品</span>
              </div>
              <div class="adjustment-line"></div>
              <div class="adjustment-table-item" @click="clickTab(2)" :class="tabIndex == 2 ? 'adjustment-table-item-active' :''">
                  <img src="@/assets/image/adjustment-img3.png" v-if="tabIndex == 2"/>
                  <img src="@/assets/image/adjustment-img2.png" v-else />
                  <span>按单据</span>
              </div>
          </div>
          <div class="materia-content" v-if="tabIndex == 1">
              <div class="commodity-shop-left">
                  <div class="commodity-left-title" @click="onSelectAll()">全部分类</div>
                  <div class="commodity-tree div-overflow">
                      <treeShopTem :searchIndex="2" @onSelectKey="onSelectKey"></treeShopTem>
                  </div>
              </div>
              <div class="mateia-right">
                  <a-table   :columns="columns"
                             :dataSource="dataSource"
                             :pagination="pagination"
                             bordered
                             @change="handleTableChange"
                             :scroll="{y:'calc(100vh - 400px)' }"
                  >
                      <template slot="name" slot-scope="text, record">
                          <div class="table-name"><img src="@/assets/image/manage_zong@2x.png"/>{{text}}</div>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                           <span class="operator">
                               <span @click.stop="changeDetail(record,1)">调整明细</span>
                           </span>
                      </template>
                  </a-table>
              </div>
          </div>
          <div class="adjust-bill" v-else>
              <a-table   :columns="columnsBill"
                         bordered
                         :dataSource="dataSourceBill"
                         :pagination="paginationBill"
                         :scroll="{x:1000,y:'calc(100vh - 360px)' }"
                         @change="handleTableChangeBill"
              >
                  <template slot="operation" slot-scope="text, record">
                       <span class="operator" @click.stop="changeDetail(record,2)">查看</span>
                  </template>

              </a-table>
          </div>
      </div>
      <materialmanageModel ref="materialmanageModel" ></materialmanageModel>
  </div>
</template>
<script>
    import treeShopTem from '@/components/treeShopTem'
    import materialmanageModel from './model/materialmanageModel'
    import locationSelect from '@/components/locationSelect'
    import {mixins} from "@/mixins/mixins";
    // import {} from "@/utils/api";
export default {
  mixins:[mixins],
  data () {
    return {
        form:this.$form.createForm(this),
        columns: [
            {
                title: '序号',
                dataIndex: '',
                key: 'rowIndex',
                width: 70,
                align: 'center',
                customRender(t, r, index) {
                    return parseInt(index) + 1
                }
            },
            {
                title: '商品名称',
                dataIndex: 'productName',
                key: 'productName',
                width:180,
                scopedSlots: { customRender: 'name' },
            },
            {
                title: '商品编号',
                key: 'productCode',
                width:180,
                ellipsis:true,
                dataIndex:'productCode',
            },
            {
                title: '规格',
                key: 'productSpecification',
                ellipsis:true,
                dataIndex:'productSpecification',
            },
            {
                title: '型号',
                key: 'productModel',
                ellipsis:true,
                dataIndex: 'productModel',
            },
            {
                title: '单位',
                key: 'productUnit',
                ellipsis:true,
                dataIndex:'productUnit',
            },
            {
                title: '数量',
                key: 'productCount',
                align: 'right',
                dataIndex:'productCount',
            },
            {
                title: '均价',
                key: 'costPrice',
                align: 'right',
                dataIndex:'costPrice',
            },
            {
                title: '金额',
                key: 'totalAmount',
                align: 'right',
                dataIndex:'totalAmount',
            },
            {
                title: '库位',
                key: 'locationName',
                dataIndex:'locationName',
                align:'left',
                ellipsis:true,
                width:180,
            },
            {
                title: '操作',
                fixed: 'right',
                width:150,
                scopedSlots: { customRender: 'operation' },
            },
        ],
        dataSource: [],
        warehouseState:0,
        recordItem:{},
        tabIndex:1,
        columnsBill:[
            {
                title: '序号',
                dataIndex: '',
                key: 'rowIndex',
                width: 70,
                align: 'center',
                customRender(t, r, index) {
                    return parseInt(index) + 1
                }
            },
          {
            title: '单据编号',
            dataIndex: 'code',
            key: 'code',
            ellipsis:true,
          },
            {
                title: '单据日期',
                dataIndex: 'voucherDate',
                key: 'voucherDate',
                ellipsis:true,
            },
            {
                title: '经办人',
                dataIndex: 'transactorName',
                key: 'transactorName',
                ellipsis:true,
            },
            {
                title: '调整仓库',
                dataIndex: 'storageName',
                key: 'storageName',
                ellipsis:true,
            },
            {
                title: '金额',
                dataIndex: 'totalAmount',
                key: 'totalAmount',
            },
            {
                title: '摘要',
                dataIndex: 'digest',
                key: 'digest',
                ellipsis:true,
            },
            {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                ellipsis:true,
            },
            {
                title: '操作',
                fixed: 'right',
                width:200,
                scopedSlots: { customRender: 'operation' },
            },
        ],
        dataSourceBill:[],
        paginationBill:{
            current: 1,
            pageSize: 10,
            showTotal: (total, range) => {
                return `共 ${total}条数据  每页${range[1]-range[0]+1}条`
            },
            showQuickJumper: true,
            showSizeChanger:true,
            total:100
        },
        formData:{},
    }
  },
  components: {
      treeShopTem,materialmanageModel,locationSelect
  },
  watch: {
      pageList(){
          if(!this.isEmpty(this.pageList.result)){
              if(this.tabIndex == 1){
                  this.pagination.current = this.pageList.result.current
                  this.pagination.total = this.pageList.result.total
                  this.pagination.pageSize = this.pageList.result.size
                  this.pages = this.pageList.result.pages
                  this.dataSource = this.pageList.result.records
              }else{
                  this.paginationBill.current = this.pageList.result.current
                  this.paginationBill.total = this.pageList.result.total
                  this.paginationBill.pageSize = this.pageList.result.size
                  this.dataSourceBill = this.pageList.result.records
              }
              this.$store.state.isLoding = false
          }
      }
  },
  mounted () {
      this.storageListSelect()
      setTimeout(()=>{
          this.$nextTick(()=>{
              this.form.setFieldsValue({
                  storageId:this.storageList[0].id
              })
              this.formData.storageId = this.storageList[0].id
              this.getList()
          })
      },1000)
  },
  created () {

  },
  methods: {
      getList(){
          this.$store.state.isLoding = true
          if(this.tabIndex == 1){
              this.getPageList('/storage/api/initialProduct/pageListInitialProductByCondition',
                      {   companyStoreId:this.$store.state.shopId,
                          keywords:this.formData.keywords,
                          productCategoryId:this.formData.productCategoryId,
                          storageId:this.formData.storageId,
                          pageNo:this.pagination.current,
                          pageSize:this.pagination.pageSize,
                      },{
                          'Content-Type':'application/json'
                      })
          }else{
              this.getPageList('/storage/api/initialStockSetup/pageListInitialStockSetupByCondition',
                      {   companyStoreId:this.$store.state.shopId,
                          keywords:this.formData.keywords,
                          storageId:this.formData.storageId,
                          pageNo:this.paginationBill.current,
                          pageSize:this.paginationBill.pageSize,
                      },{
                          'Content-Type':'application/json'
                      })
          }

      },
      handleChangeStorage(value){
          this.formData.storageId = value
          this.getList()
      },
      /**
       * @description: 表格页数切换（方法描述）
       */
      handleTableChange(pagination, filters, sorter){
          this.pagination.current = pagination.current
          this.pagination.pageSize = pagination.pageSize
          this.getList()
      },
      /**
       * @description: 表格页数切换（方法描述）
       */
      handleTableChangeBill(pagination, filters, sorter){
          this.paginationBill.current = pagination.current
          this.paginationBill.pageSize = pagination.pageSize
          this.getList()
      },
      //分类回调
      onSelectKey(value){
          this.formData.productCategoryId = value
          this.onSearch()
      },
      onSelectAll(){
          this.formData.productCategoryId = ''
          this.onSearch()
      },
      /**
       * @description: 搜索（方法描述）
       */
      onSearch(){
          this.form.validateFields((err, values) => {
              if (!err) {
                  this.pagination.current = 1
                  this.formData.keywords = values.keywords
                  this.formData.storageId = values.storageId
                  this.getList()
              }
          })
      },
      /**
       * @description: 重置（方法描述）
       */
      onRest(index){
          this.formData.productCategoryId = ''
          this.formData.keywords = ''
          this.formData.storageId = ''
          this.pagination.current = 1
          this.form = this.$form.createForm(this)
          this.$nextTick(()=>{
              this.form.setFieldsValue({
                  storageId:this.storageList[0].id
              })
          })
          this.warehouseState = 0
          this.formData.storageId = this.storageList[0].id
          this.getList()
      },
      /**
       * @description: 盘点和变化明细（方法描述）
       */
      changeDetail(record,index){
          let name = ''
          this.storageList.forEach((item)=>{
              if(item.id ==  this.formData.storageId){
                  name = item.storageName
              }
          })
          if(index == 1){
              let arr = JSON.stringify({
                  id:record.productId,
                  productName:record.productName,
                  storageName:name,
                  type:1
              })
              this.$router.push('/librarymanage/warehousemanage/materialmanageDetails?item='+arr)
          }else{
              this.$router.push('/librarymanage/warehousemanage/adjustmentDetail?id='+record.id)
          }
      },
      /**
       * @description: tab的改变（方法描述）
       */
      clickTab(index){
          this.form = this.$form.createForm(this)
          this.$nextTick(()=>{
              this.form.setFieldsValue({
                  storageId:this.storageList[0].id
              })
          })
          this.formData.storageId = this.storageList[0].id
          this.tabIndex = index
          this.getList()
      },
  },
}
</script>
<style lang="scss">
    .materia-form{
        .ant-form-item{
            width: 100%;
            .ant-form-item-control-wrapper{
                width: 100%;
            }
        }
    }
    .mateia-right{
        .ant-table-wrapper{
            padding: 0;
        }
        .ant-table{
            height: calc(100vh - 340px);
        }
        .ant-table-body,.ant-table-body-inner{
            max-height: calc(100vh - 400px) !important;
        }
        .ant-table-scroll{
            .ant-table-tbody > tr > td{
                border-right: 1px solid #f0f0f0;
            }
            .ant-table-tbody > tr > td:nth-child(2){
                border-right: 1px solid transparent;
            }
        }
        .ant-table-fixed{
            .ant-table-tbody > tr > td{
                border-right: 1px solid #f0f0f0;
            }
        }
        .tab-row-warn{
            td{
                color: #AAAAAA;
            }

        }
    }
    .adjust-bill{
        .ant-table{
            height: calc(100vh - 310px);
        }
        .ant-table-body,.ant-table-body-inner{
            max-height: calc(100vh - 360px) !important;
        }
    }

</style>
<style lang="scss" scoped>
    .page-container-height{
        background-color: #fff;
        /*padding: 20px 18px 0;*/
        .material-top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 18px 0;
            .material-top-left{
                flex: 1;
                .materia-form-num{
                    padding-left: 22px;
                    span{
                        color: var(--co);
                        font-size: 18px;
                        font-weight: 700;
                    }
                }
                .materia-form-shua{
                    padding-left: 33px;
                    color: #387BFC;
                    img{
                        width: 16px;
                        margin-bottom: 2px;
                    }
                }
            }
            .material-top-right{
                width: 100px;
                background:rgba(250,250,250,1);
                color: var(--co);
                position: relative;
                .material-btn-pos{
                    position: absolute;
                    top: 45px;
                    right: 0;
                    width:165px;
                    height:90px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 8px 0px rgba(59,59,59,0.16);
                    border-radius:6px;
                    color: #333333;
                    z-index: 100;
                    padding: 10px 0;
                    .material-btn-pos-title{
                        height: 36px;
                        line-height: 36px;
                        cursor: pointer;
                    }
                    .material-btn-pos-title:hover{
                        background-color: #EBF2FD;
                    }
                }
            }
        }
        .adjustment-table{
            display: flex;
            padding-left: 18px;
            margin: 10px 0 6px 0;
            .adjustment-table-item{
                color: #919191;
                font-size: 16px;
                margin-right: 32px;
                cursor: pointer;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 12px;
                }
            }

            .adjustment-table-item-active{
                color: #387BFC;
            }
        }
        .materia-content{
            display: flex;
            padding:  0 18px;
            .commodity-shop-left{
                width: 200px;
                height: calc(100vh - 340px);
                margin-right: 12px;
                overflow: hidden;
                border: 1px solid #DDDDDD;
                .commodity-left-title{
                    cursor: pointer;
                    height: 45px;
                    line-height: 45px;
                    color: #333333;
                    font-size: 16px;
                    padding-left: 10px;
                }
                .commodity-tree{
                    padding-left: 10px;
                    overflow-y: auto;
                    overflow-x: hidden;
                }
            }
            .mateia-right{
                flex: 1;
                overflow: hidden;
                width: calc(100% - 250px);
                .table-name{
                    width: 220px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    img{
                        width: 22px;
                        margin-right: 4px;
                    }
                }
                .operator{
                    color: #387BFC;
                    span{
                        cursor: pointer;
                    }
                    span:last-child{
                        margin-left: 14px;
                    }
                    .operator-span{
                        color: #AAAAAA;
                    }
                }
            }
        }
        .location-span{
            padding-right:20px;
            display: inline-block;
            height: 30px;
            width: 100%;
            line-height: 30px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .adjust-bill{
            .operator {
                cursor: pointer;
                color: #387BFC;
            }
        }
    }
</style>


